import React from 'react';
import { Section } from './Section';
import { Button } from './Button';
import { BookOpen, ShoppingCart, Sparkles, Utensils, LineChart } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-forest" data-id="element-104" />,
    title: 'El Protocolo de 3 Días',
    desc: 'El paso a paso exacto de qué comer desde que despiertas hasta que duermes.'
  }, {
    icon: <ShoppingCart className="w-8 h-8 text-forest" data-id="element-105" />,
    title: 'Manual de Supermercado USA',
    desc: 'Lista de compras probada para Walmart, Target y Costco.'
  }, {
    icon: <Sparkles className="w-8 h-8 text-forest" data-id="element-106" />,
    title: 'El Ritual del Masaje Linfático',
    desc: 'Una técnica de 5 minutos que puedes hacer en la ducha para drenar tu abdomen.'
  }, {
    icon: <Utensils className="w-8 h-8 text-forest" data-id="element-107" />,
    title: 'Guía de Restaurantes',
    desc: 'Aprende qué pedir para no inflamarte cuando te toca comer fuera de casa.'
  }, {
    icon: <LineChart className="w-8 h-8 text-forest" data-id="element-108" />,
    title: 'Rastreador de Resultados',
    desc: 'Hoja de trabajo para medir tu desinflamación real cada 24 horas.'
  }];
  return <Section className="bg-cream" data-id="element-109">
      <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-12 text-center" data-id="element-110">
        Lo que obtienes hoy
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-111">
        {items.map((item, index) => <div key={index} className={`bg-white p-6 rounded-xl shadow-md border border-sage flex flex-col items-center text-center ${index === items.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-112">
            <div className="bg-sage w-16 h-16 rounded-full flex items-center justify-center mb-4" data-id="element-113">
              {item.icon}
            </div>
            <h3 className="font-serif text-xl font-bold text-forest mb-2" data-id="element-114">
              {item.title}
            </h3>
            <p className="text-gray-600" data-id="element-115">{item.desc}</p>
          </div>)}
      </div>
      <div className="text-center" data-id="element-116">
        <Button data-id="element-117">QUIERO MI PROTOCOLO AHORA</Button>
      </div>
    </Section>;
}